export interface IProductCategory {
  _id: string;
  id: number;
  name: string;
  slug?: string;
  class?: string;
  h1_tag?: string;
  filter_through?: string;
  description?: string;
  title_tag?: string;
  front_description?: string;
}
